import React, { useState } from 'react'
import { Box, Button, Divider, Select, Input } from '@chakra-ui/core'
import dayjs from 'dayjs'
import { setRemoteCall } from '../../../remote'
import { useGlobalState, getGlobalState } from '../../../store'

const AddPerson = (props) => {
  const { data, relataion, project, column, setView, setOpen, type } = props
  const [selectedType, setSelectedType] = useState(null)
  const [selectedResource, setSelectedResource] = useState(null)
  const [inputValue, setInputValue] = useState('')
  const projects = getGlobalState('projects')
  const userTypes = getGlobalState('userTypes')
  // const userTypes = getGlobalState('userTypes')
  const users = getGlobalState('users')

  //Remove resource from project
  const moveResourceToProject = (e) => {
    //then we can add the new relation

    const thisProjects = projects.find((prj) => prj._id === project?.id)
    console.log({
      dateStart: column?.date,
      dateEnd: thisProjects && dayjs(thisProjects.endDate).format('DD/MM/YYYY'),
      projectId: thisProjects?._id,
      accountId: data?.userId,
      resource: {
        ...selectedResource,
        cardType: 'users',
      },
      sort: 1,
    })
    setRemoteCall(
      'setRelationToProject',
      {
        dateStart: column?.date,
        dateEnd:
          thisProjects && dayjs(thisProjects.endDate).format('DD/MM/YYYY'),
        projectId: thisProjects?._id,
        accountId: data?.userId,
        resource: {
          ...selectedResource,
          cardType: 'users',
        },
        sort: 1,
      },
      null
    )

    setView(null)
    setOpen(false)
  }

  return (
    <>
      <Select
        size={'sm'}
        placeholder="Selecione um tipo"
        onChange={(e) => {
          setSelectedType(e.target.value)
          setInputValue('')
          setSelectedResource(null)
        }}
      >
        {userTypes.map(
          (t) => t.status === 1 && <option value={t._id}> {t.name}</option>
        )}
      </Select>
      {selectedType ? (
        <>
          <Input
            size={'sm'}
            placeholder="Selecione um recurso"
            value={inputValue}
            onChange={(e) => {
              setInputValue(e.target.value)
              // Find the resource that matches the input display value
              const foundResource = users?.find(
                (r) =>
                  r.role === selectedType &&
                  r.status === 1 &&
                  `${r.firstName} ${r.lastName}, ${r.code}` === e.target.value
              )
              if (foundResource) {
                setSelectedResource(foundResource)
              } else {
                setSelectedResource(null)
              }
            }}
            list="usersPicker"
          />
          <datalist id="usersPicker">
            {users
              ?.filter((r) => {
                return r.role === selectedType && r.status === 1
              })
              ?.map((t) => {
                return (
                  <option
                    key={t._id}
                    value={`${t.firstName} ${t.lastName}, ${t.code}`}
                  >
                    {t.firstName} {t.lastName}, {t.code}
                  </option>
                )
              })}
          </datalist>
        </>
      ) : null}
      <Button
        size="sm"
        w={'100%'}
        mt={2}
        onClick={() => moveResourceToProject()}
        className="actionsButton"
        variantColor="red"
        variant="outline"
      >
        <i className="icons icon-share-alt" style={{ marginRight: '4px' }} />
        Mover para obra
      </Button>
      <Button
        w={'100%'}
        size="sm"
        fontSize={'.8em'}
        onClick={() => setView(null)}
        variant="outline"
      >
        Cancelar
      </Button>
    </>
  )
}

export default AddPerson
